import { memo } from "react";
import { Button } from "antd";
import { useTranslation } from "react-i18next";
import { MdOutlineFilterList } from "react-icons/md";

const Filter = ({
  id = "btn-filter",
  title,
  icon = <MdOutlineFilterList size={20} />,
  type = "default",
  onClick = () => {},
  ...props
}) => {
  const { t } = useTranslation();
  const btnTitle = title ? title : t("button.filter");

  return (
    <Button id={id} type={type} title={btnTitle} onClick={onClick} {...props}>
      <div className="flex items-center justify-center space-x-2">
        {icon}
        <span>{btnTitle}</span>
      </div>
    </Button>
  );
};

export default memo(Filter);
